import { Component, OnInit, ElementRef } from '@angular/core';
import { SharedService } from '../shared.service';
import { Router } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import { NotificationService } from '../services/notification/notification.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  notifications: any = [];
  constructor(private sharedService: SharedService,
              private toastrService: ToastrService,
              private router: Router,
              private notificationService: NotificationService
    ) { }

  ngOnInit() {
    this.checkNotificaiton();
    // debugger
    this.getAllNotifications();
  }
  private startHttpRequest = () => {
    // this.signalRService.startConnection();
    // this.signalRService.AddGetNotificationListener();
    // // debugger
    // this.signalRService.getInAppNotificationById('101').subscribe(res => {
    //   console.log(res);
    // });
  }

  getAllNotifications() {

    // this.signalRService.getNotifications()
    //   .subscribe(res => {
    //     this.notifications = res;
    //   });
  }
  showNotifications() {
    // console.log ("callig toaster");
    for (let i = 0; i < this.notifications.length; i++) {
      this.openNotification(this.notifications[i]);
    }
  }

  // toaster body to display the messages
  openNotification(notification) {
    const toaster = this.toastrService.success(notification.body, notification.subject,
      {
        timeOut: 10000,
        disableTimeOut: true,
        closeButton: true,
        positionClass: 'toast-bottom-right'
      });

    // method to read the endpopintURL
    notification.toastId = toaster.toastId;
    toaster.onTap.subscribe(t => {
      this.notificationService.markRead(notification).subscribe(res => {
        this.router.navigate[notification.endpopintURL];
      });
    });
  }

  // browser notification allow or decline method
  checkNotificaiton() {
    // debugger
    if (!('Notification' in window)) {
      console.log('this browser does not support notification');
      return;
    }
    if (Notification.permission === 'granted') {
      this.startHttpRequest();
      return; // noting to do
    }
    if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(perm => {
        console.log('herer is permm..', perm);

        if (perm == 'granted') {
          this.startHttpRequest();
          new Notification('Notifications');
        }
      });
    }
  }
}
